/* eslint-disable @next/next/no-img-element */
import { PAYMENT_MESSAGE } from '../../../brands/default/content/components/checkout';
import { EXCLAMATION_CIRCLE_RED } from '../../../config/constants/images';

const PaymentMessage = () => {
  return (
    <>
      <div className="payment-message">
        <img
          alt="Exclamation Circle Red"
          className="exclamation-circle-red"
          src={EXCLAMATION_CIRCLE_RED}
        />

        <p>{PAYMENT_MESSAGE.oopsPayment}</p>
        <p className="middle-message"> {PAYMENT_MESSAGE.notProcess}</p>
        <p>{PAYMENT_MESSAGE.tryAgainPlease}</p>
      </div>
      <style jsx>{`
        .exclamation-circle-red {
          margin-bottom: 10px;
          width: 60px;
        }
        .middle-message {
          background: #d00303;
          color: white;
        }
        .payment-message {
          display: block;
          font-size: 1.5rem;
          font-weight: bold;
          text-align: center;
        }
      `}</style>
    </>
  );
};

PaymentMessage.propTypes = {};

export default PaymentMessage;
